import { useEffect, useState } from "react";
import LoginButton from "components/auth/LoginButton";
import { useAuth } from "context/AuthContext";
import {
  clearLoginError,
  consumeLoginError,
  getLoginErrorMessage,
  hasStoredLoginError,
} from "auth/loginErrors";
import { isAutoSignInDisabled } from "auth/autoSignIn";

export default function Login() {
  const { lang } = useAuth();
  const locale = lang === "es" ? "es" : "en";
  // Latched before the effect below clears the code, and kept across the
  // re-render that shows the message.
  const [arrivedWithError] = useState(hasStoredLoginError);
  const [signedOut] = useState(isAutoSignInDisabled);
  const [loginError, setLoginError] = useState<string | null>(null);

  useEffect(() => {
    const code = consumeLoginError();
    if (code) {
      setLoginError(getLoginErrorMessage(code, locale));
    }
  }, [locale]);

  return (
    <div className="bg-white rounded-2xl shadow-xl p-6 lg:p-10 flex flex-col items-center w-full max-w-sm mx-4 lg:mx-0">
      <img
        src="logo192.png"
        alt="App Logo"
        className="w-16 h-16 lg:w-20 lg:h-20 mb-4 lg:mb-6 rounded-full border-2 border-blue-200 bg-gray-100 object-contain shadow"
      />
      <h1 className="text-xl lg:text-2xl font-bold mb-2 text-gray-800 text-center">
        {locale === "es" ? "Bienvenido a Eloria" : "Welcome to Eloria"}
      </h1>
      <p className="text-gray-600 mb-6 lg:mb-8 text-center text-xs lg:text-sm max-w-xs">
        {locale === "es"
          ? "Iniciá sesión con Google para acceder a tu panel, gestionar tus edificios y aprovechar todo lo que Eloria puede hacer por vos."
          : "Sign in with Google to access your dashboard, manage your buildings, and take advantage of everything Eloria can do for you."}
      </p>
      {loginError && (
        <p
          role="alert"
          className="mb-4 w-full rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-center text-xs text-red-800"
        >
          {loginError}
        </p>
      )}
      <LoginButton
        allowAutoSignIn={!arrivedWithError && !signedOut}
        onLoginError={(message) => setLoginError(message)}
        onLoginStart={() => {
          clearLoginError();
          setLoginError(null);
        }}
      />
    </div>
  );
}
